var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V3.41c0-.89-1.08-1.34-1.71-.71L4 6H1c-.55 0-1 .45-1 1zm13.5 2A4.5 4.5 0 0011 4.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM11 1.45v.2c0 .38.25.71.6.85A7.004 7.004 0 0116 9c0 2.94-1.82 5.47-4.4 6.5-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85A8.98 8.98 0 0018 9c0-3.84-2.4-7.11-5.79-8.4-.58-.23-1.21.22-1.21.85z",
    fill: "currentColor"
  })));
};
export default SvgSound;